import styles from "@css/modules/pointsGuide.module.scss"
import { Carousel } from "@components/Animation/Carousel"
import { ArrowLeft } from "@css/icons/SVG"
import React, { useMemo } from "react"
import Image from "next/image"

export function ResortsCarousel({ resorts, resort, setResort }) {
    const index = useMemo(() => {
        return resorts.findIndex((i) => i.id === resort.id)
    }, [resort, resorts])
    const prevBtn = (click) => (
        <button onClick={click} className={styles.prevBtn} aria-label="go prev">
            <ArrowLeft />
        </button>
    )
    const nextBtn = (click) => (
        <button onClick={click} className={styles.nextBtn} aria-label="go next">
            <ArrowLeft />
        </button>
    )
    const onChange = (index) => {
        const res = resorts[index]
        if (res !== resort) {
            setResort(res)
        }
    }
    return (
        <>
            <div className={styles.step6CarouselRoot}>
                <Carousel
                    startAt={index}
                    autoplayTime={0}
                    classNames={{
                        itemActive: styles.itemActive,
                        item: styles.item,
                        itemNext: styles.itemNext,
                        itemNext2: styles.itemNext2,
                        itemPrev: styles.itemPrev,
                        itemPrev2: styles.itemPrev2,
                        root: styles.carousel
                    }}
                    onChange={onChange}
                    prevBtn={prevBtn}
                    nextBtn={nextBtn}
                    items={resorts.map((i, key) => {
                        const logo = i?.logo?.formats || {}
                        const format = logo.small || logo.thumbnail || {}
                        return (
                            <Image
                                key={key}
                                className={styles.carouselImage}
                                alt={i?.logo?.alternativeText || i.short_name}
                                loading={key === index ? "eager" : "lazy"}
                                height={format.height}
                                src={format.url}
                                width={format.width}
                            />
                        )
                    })}
                />
            </div>
            <div className={styles.overResortDesc}>
                <h4>{resort.short_name}</h4>
                <p>{resort.description}</p>
            </div>
        </>
    )
}
